/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
export class ModalState {
  multiSelectPanelOpen: boolean = false;

  inviteModalOpen: boolean = false;

  sharePanelOpen: boolean = false;
}
